export default __webpack_public_path__ + "static/media/vault.e4f3ea56.svg";